import React, { useRef, useState } from "react";
import { StyledImg } from "./AvatarSelector.styled";

interface Props {
    setAvatar: Function
    round: boolean
}

const AvatarSelector = (props: Props) => {
    
    const [preview, setPreview] = useState<string | null>(null);
    const [error, setError] = useState<string | null>(null);
    const fileInputRef = useRef<HTMLInputElement>(null);

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            // Validate file type (PNG, JPG only)
            if (!["image/png", "image/jpeg"].includes(file.type)) {
                setError("Please upload a valid image file (PNG or JPG).");
                props.setAvatar(null);
                setPreview(null);
                return;
            }

            // Validate file size (max 2MB)
            const maxSizeInMB = 2;
            if (file.size > maxSizeInMB * 1024 * 1024) {
                setError(`File size should not exceed ${maxSizeInMB}MB.`);
                props.setAvatar(null);
                setPreview(null);
                return;
            }

            setError(null); // Clear errors
            props.setAvatar(file);

            // Create preview URL
            const previewURL = URL.createObjectURL(file);
            setPreview(previewURL);
        }
    };

    const handleTextClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click(); // Programmatically trigger file input click
        }
    };

    const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault(); // Prevent default behavior to allow dropping
    };

    const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();

        const file = event.dataTransfer.files[0]; // Get the first dropped file
        if (file && file.type.startsWith("image/")) {
            const previewURL = URL.createObjectURL(file); // Create preview URL
            setPreview(previewURL); // Set the preview
        } else {
            alert("Please drop a valid image file.");
        }
    };

    return (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "start" }}>
            {/* Avatar Preview */}
            <div
                style={{
                    width: '100%',
                    height: 150,
                    borderRadius: "20px",
                    overflow: "hidden",
                    border: "2px solid #ddd",
                    marginBottom: "1rem",
                    maxWidth: '500px',
                    cursor: 'pointer',
                    display: 'flex',
                    justifyContent: 'center'
                }}
                onClick={handleTextClick}
                onDragOver={handleDragOver}
                onDrop={handleDrop}
            >
                {preview ? (
                    <StyledImg 
                        className={`${props.round ? "round" : ""}`}
                        src={preview}
                        alt="Avatar Preview"
                    />
                ) : (
                    <p
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                            fontSize: "14px",
                            color: "#FFF",
                            opacity: '0.5',
                            textAlign: 'center',
                            padding: '0 40px',
                            margin: 0
                        }}
                    >
                        Drag and Drop an image here or select one for upload
                        Selectable files: PNG or JPG | Maximun size: 2MB
                    </p>
                )}
            </div>

            {/* File Input */}
            <input
                type="file"
                ref={fileInputRef}
                accept="image/png, image/jpeg"
                onChange={handleFileChange}
                style={{ marginBottom: "1rem", display: 'none' }}
            />

            {/* Error Message */}
            {error && <p style={{ color: "red", marginBottom: "1rem" }}>{error}</p>}
            
        </div>
    );
};

export default AvatarSelector;